
export const validateEmail = (email: string) => {
    const validRegex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;

    if (email.match(validRegex)) {
        return false;
    } else {
        return true;
    }
}

export const pathLink = process.env.REACT_APP_API_URL || 'https://itcbootcamp.com:4443'

export const videoLink = `${pathLink}/api/cources/stream/`

/**
 * Приводит ссылку на файл из API к рабочему виду.
 *
 * Раньше по коду было раскидано `https${url.slice(4)}` — обрезка четырёх
 * символов в расчёте на то, что сервер всегда отдаёт http. Как только API
 * начал отдавать https, хак превращал ссылку в httpss:// и картинки
 * переставали грузиться.
 */
export const mediaUrl = (url?: string | null): string => {
    if (!url) return ''
    if (/^https:\/\//i.test(url)) return url
    if (/^http:\/\//i.test(url)) return `https://${url.slice(7)}`
    return `${pathLink}${url.startsWith('/') ? '' : '/'}${url}`
}